// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2c-q";
export var animationRelative = "_2c-p";
export var backdropBlur = "_2c-0";
export var detailLabelCell = "_2c-12";
export var detailTable = "_2c-11";
export var detailValueCell = "_2c-13";
export var docIconBox = "_2c-1d";
export var docIconBoxMd = "_2c-1f";
export var docIconBoxSm = "_2c-1e";
export var docTypeRow = "_2c-16";
export var docTypeRowInner = "_2c-17";
export var dropdownMatchDatePicker = "_2c-3";
export var evidenceCardContent = "_2c-1c";
export var fileUploadSpin = "_2c-j";
export var gorgiasOpenButton = "_2c-15 _2c-d";
export var gorgiasTicketCard = "_2c-14";
export var heroModalFooterButton = "_2c-18";
export var hiddenContainer = "_2c-o";
export var iconPrimary = "_2c-1g";
export var iconQuaternary = "_2c-1i";
export var iconTertiary = "_2c-1h";
export var integrationCard = "_2c-1";
export var integrationLogoBox = "_2c-2";
export var mainColumnSticky = "_2c-1b";
export var maxWidthContainer = "_2c-19";
export var modalContentBody = "_2c-a";
export var modalHeaderImage = "_2c-5";
export var modalImageLabel = "_2c-7";
export var modalImageOverlay = "_2c-6";
export var modalImageSubtitle = "_2c-9";
export var modalImageTitle = "_2c-8";
export var modalImageWrapper = "_2c-4";
export var modalStickyFooter = "_2c-b";
export var removeButton = "_2c-e";
export var sidebarColumn = "_2c-1a";
export var spinner = "_2c-i";
export var timelineLine = "_2c-y";
export var timelineLineBlack = "_2c-10 _2c-y";
export var timelineLineGray = "_2c-z _2c-y";
export var timelineLineHeight = "_2c-x";
export var tlDotActivate = "_2c-u";
export var tlDotActivateAnim = "_2c-t";
export var tlDotHide = "_2c-s";
export var tlDotHideAnim = "_2c-r";
export var tlLineActivate = "_2c-w";
export var tlLineActivateAnim = "_2c-v";
export var uploadHint = "_2c-n";
export var uploadIconBox = "_2c-k";
export var uploadLabel = "_2c-m";
export var uploadText = "_2c-l";
export var uploadZone = "_2c-f";
export var uploadZoneCursorDefault = "_2c-h";
export var uploadZoneCursorPointer = "_2c-g";
export var uploadedFileRow = "_2c-c";
export var viewButton = "_2c-d";